<template>
    <div>
        <div
            v-if="memberId === assignmentJob.memberId"
            v-html="$t('Bitte lege jetzt das Zutrittsmedium für {member} auf den GAT Writer.', { member: getMemberName })"
        ></div>
        <div
            v-else
            v-html="$t('Es läuft bereits eine Zutrittsmedium-Zuweisung für das Mitglied {member}.', { member: getMemberName })"
        ></div>
        <div
            class="countdown"
            v-html="$t('Diese Zuweisung ist in {counter} Sekunden abgelaufen.', { counter: getCountdown })"
        ></div>
    </div>
</template>

<script>
import ClubMemberAccessMediumAssignmentJob from '../../../js/dto/ClubMemberAccessMediumAssignmentJob';

export default {
    props: {
        assignmentJob: {
            type: ClubMemberAccessMediumAssignmentJob,
            required: true,
        },
        memberId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            countDown: 0,
        };
    },
    computed: {
        getMemberName() {
            return `<span style="font-weight: var(--kgr-font-weight-bold);">${this.assignmentJob.memberName}</span>`;
        },
        getCountdown() {
            return `<span style="font-weight: var(--kgr-font-weight-bold)">${this.countDown}</span>`;
        },
    },
    mounted() {
        this.startCountdown();
    },
    methods: {
        countDownTimer() {
            if (this.countDown >= 0) {
                setTimeout(() => {
                    this.countDown--;
                    this.countDownTimer();
                }, 1000);
            } else {
                this.$emit('close');
            }
        },
        startCountdown() {
            this.countDown = Math.round((this.assignmentJob.validUntil.getTime() - Date.now()) / 1000);
            this.countDownTimer();
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    div.countdown {
    margin-top: 25px;
}
</style>
